<template>
  <div v-if="role">
    <h1>Role</h1>
    <v-btn :to="{name:'roles'}">
      <v-icon>chevron_left</v-icon>Roles
    </v-btn>
    <v-form ref="formRole" v-model="valid" lazy-validation>
      <v-text-field label="Id" v-model="role.id" v-if="computedEditing" outline readonly />
      <v-text-field
        label="Name"
        v-model="role.name"
        :rules="valueRules"
        :readonly="computedEditing"
        outline
      />
      <v-text-field label="Description" v-model="role.description" :rules="valueRules" outline />
      <v-btn @click="saveRole">
        <v-icon>save</v-icon>Save
      </v-btn>
    </v-form>
    <template v-if="entities">
      <h3>Users</h3>
      <v-data-table
        :pagination.sync="pagination"
        :headers="headers"
        :items="entities"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <tr>
            <td>
              <EntityZ :entity="props.item" />
            </td>
            <td>other</td>
          </tr>
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Role",
  metaInfo() {
    return {
      title: "Role",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    EntityZ
  },
  computed: {
    computedEditing() {
      return this.$route.params.id ? true : false;
    }
  },
  data() {
    return {
      role: null,
      entities: null,
      valid: false,
      valueRules: [v => !!v || "Value is required"],
      headers: [
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Other",
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "name",
        descending: false
      }
    };
  },
  methods: {
    fetchRole() {
      nbmlaw
        .get(`/cors/admin/directory/roles/${this.$route.params.id}`)
        .then(response => {
          // console.log(response.data);
          this.role = response.data;
        })
        .catch(() => {});
    },
    fetchEntities() {
      nbmlaw
        .get(`/cors/admin/directory/roles/${this.$route.params.id}/entities`)
        .then(response => {
          // console.log(response.data);
          this.entities = response.data;
        })
        .catch(() => {});
    },
    saveRole() {
      if (this.$refs.formRole.validate()) {
        if (this.$route.params.id) {
          this.updateRole();
        } else {
          this.createRole();
        }
      }
    },
    updateRole() {
      nbmlaw
        .put(`/cors/admin/directory/roles/${this.$route.params.id}`, this.role)
        .then(() => {
          this.$router.push({ name: "roles" });
        })
        .catch(() => {});
    },
    createRole() {
      nbmlaw
        .post(`/cors/admin/directory/roles`, this.role)
        .then(() => {
          this.$router.push({ name: "roles" });
        })
        .catch(() => {});
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.fetchRole();
          this.fetchEntities();
        } else {
          this.role = {};
        }
      }
    }
  }
};
</script>
